import { createContext } from "react";
import { User } from "@auth0/auth0-react";

export type AuthType = {
  user: User & { permissions: string[]; roles: string[] };
  getToken: () => unknown;
};

export type AuthContextProps = {
  auth: AuthType | null;
  login: () => void;
  logout: () => void;
  authReady: boolean; // Adicionar esta propriedade
};

const initContextData: AuthContextProps = {
  auth: null,
  login: () => null,
  logout: () => false,
  authReady: false // Valor inicial
};

export const AuthContext = createContext<AuthContextProps>(initContextData);